import {IntrospectionFragmentMatcher} from "apollo-cache-inmemory"

export const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: require("./schema").data,
})



// WEBPACK FOOTER //
// ./src/graphql/fragmentMatcher.tsx